module.exports = ".confirm-header {\n  color: green; }\n\n.mail {\n  color: blue; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/confirm-email-sent-dialog/confirm-email-sent-dialog.component.scss
// module id = 173
// module chunks = 1